import { Box, Typography } from "@mui/material";
import qualityMain from "../../../../assets/Quality&Compliance.png";
import qualityMob from "../../../../assets/Quality&ComplianceMob.png";
import ukca from "../../../../assets/ukca.jpg";
import ce from "../../../../assets/ce.jpg";
import iso from "../../../../assets/iso.avif";
import FadeInBox from "../../../../commonComponents/FadeInBox";

const complienceLogos = [ukca, ce, iso];

const Quality = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        pl: { xs: 4, md: 15 },
        pr: { xs: 4, md: 15 },
        rowGap: 2,
      }}
    >
      <FadeInBox delay={0.2} triggerOnScroll={true} triggerOnMount={false}>
        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "25px", md: "30px" },
            fontWeight: 700,
            fontFamily: "Montserrat",
            textAlign: "center",

            animation: "shimmer 3s linear infinite",
            "@keyframes shimmer": {
              "0%": {
                backgroundPosition: "0% center",
              },
              "100%": {
                backgroundPosition: "200% center",
              },
            },
          }}
        >
          Quality & Complience{" "}
        </Typography>
      </FadeInBox>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={window.innerWidth < 768 ? qualityMob : qualityMain}
          alt="Quality & Compliance"
          sx={{
            width: "100%",
            maxWidth: "100%",
            height: "auto",
            display: "block",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 1, md: 2 },
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {complienceLogos.map((logo, index) => (
            <FadeInBox
              key={index}
              delay={index * 0.2}
              triggerOnScroll={true}
              triggerOnMount={false}
            >
              <Box
                component="img"
                src={logo}
                alt={`Compliance logo ${index + 1}`}
                sx={{
                  width: { xs: "100px", sm: "120px", md: "180px" },
                  height: "auto",
                  objectFit: "contain",
                  padding: { xs: "12px", md: "16px" },
                  borderRadius: { xs: "12px", md: "16px" },
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  boxShadow:
                    "0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px) scale(1.05)",
                    boxShadow:
                      "0 8px 20px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.15)",
                  },
                }}
              />
            </FadeInBox>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
export default Quality;
